import { ComponentProps } from "./types";
import Badges from "./variants/Badges";
import Default from "./variants/Default";

export default function Tags(props: ComponentProps) {
  switch (props.variant) {
    case "badges":
      return <Badges {...props} />;
    default:
      return <Default {...props} />;
  }
}
